<template>
    <Breadcrumbs main="Form Controls" title="Checkbox & Radio" />
    <div class="container-fluid">
        <div class="row">
            <defaultCheckbox />
            <customCheckbox />
            <defaultRadio />
            <imagesCheckbox />
            <imagesRadio />
            <custumRadio />
            <defaultSwitches />
            <inlineInput />
            <animatedButtons />
            <checkboxRadio />
            <radioToggle />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const defaultCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/defaultCheckbox.vue"))
const customCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/customCheckbox.vue"))
const defaultRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/defaultRadio.vue"))
const imagesCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/imagesCheckbox.vue"))
const imagesRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/imagesRadio.vue"))
const custumRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/custumRadio.vue"))
const defaultSwitches = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/defaultSwitches.vue"))
const inlineInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/inlineInput.vue"))
const animatedButtons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/animatedButtons.vue"))
const checkboxRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/checkboxRadio.vue"))
const radioToggle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/radioToggle.vue"))
</script>